import { react2angular } from 'react2angular';
import {CarView} from './CarView';

angular.module('webtip.module')
  .component('carViewGridletModule', react2angular(CarView,[],['CommonService', 'ConditionService', 'EventsService', '$uibModal']));
